var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tagdiv",class:{ tag: true, selected: _vm.isSelected },on:{"click":_vm.toggleSelection}},[_c('span',{staticClass:"tag-text"},[_vm._v(_vm._s(_vm.tag))]),(_vm.isSelected)?_c('span',{},[_c('i',{staticClass:"flaticon2-check-mark",staticStyle:{"color":"#33b985"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }